import React from "react";
import PhotosMascota from "./photosMascota";
import { TypesHightPhoto} from "../constants/constants";
import { connect } from "react-redux";
import { isThereUrl, validateThereUrl } from "../mascotas/util-functions";

const mapState = (state) => {
	return {
        "poliza": state.polizas.poliza,
	    "ramo": state.polizas.ramoActual,
	};
};
const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		}
	};
};
class TarjetaVacunacion extends React.Component {

    render() {
        let isThereImageVacunacion;
        let imgCartilla;
        let typeHightPhoto;
        if (this.props.poliza.links_cartilla) {
            isThereImageVacunacion = isThereUrl(this.props.poliza.links_cartilla[0].url) !== "";
            imgCartilla = validateThereUrl(this.props.poliza.links_cartilla[0].url)
            typeHightPhoto = isThereImageVacunacion ? TypesHightPhoto.cartilla : TypesHightPhoto.default;
        }
  
        return <div className="card card_photos">
        <div className="card_header-photos card_header_photos--vacunacion">
            <div className="card_header_vacunacion--left">
                <div className="card_header_icon-photos">
                        <i> <img src={require("../img/imageIcon.svg")} alt="image-icon" /></i>
                </div>
                <div className="card_header_title-photos">
                        <span>Documentos</span>
                </div>
            </div>
        </div>
        <div className="card_content-photos card_content--display">
                              <div className="card_content_preview-photos card_content--width-photos">
                               { 
                                 this.props.poliza.links_cartilla &&  <PhotosMascota 
                                 url={imgCartilla} 
                                 footerTitle={"Cartilla de vacunación"} 
                                 hight={typeHightPhoto} withFooter={isThereImageVacunacion} />

                               }
                              </div>
        </div>
      </div>
    }
}
export default connect(mapState, mapDispatch) (TarjetaVacunacion);


// WEBPACK FOOTER //
// ./src/home/tarjetaVacunacion.cmpt.js